import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function OutboundIcon(props: IconProps) {
    return <Icon {...props} iconKey={"outbound"}/>
}
